import { Button } from "@/components/shadcn/button";
import { Icon } from "@iconify-icon/solid";
import { splitProps } from "solid-js";

export const LoadingButton = (props) => {
  return (
    <Button disabled={props.loading} {...props}>
      {props.loading && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="mr-2 h-4 w-4 animate-spin"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6V3m4.25 4.75L18.4 5.6M18 12h3m-4.75 4.25l2.15 2.15M12 18v3m-4.25-4.75L5.6 18.4M6 12H3m4.75-4.25L5.6 5.6"
          />
          <title>Loading</title>
        </svg>
      )}
      {props.children}
    </Button>
  );
}

export const LoadingIcon = (props) => {
  return (
    <Button variant={props.variant ?? 'default'} class="w-8 h-8" disabled={props.loading} {...props}>
      {props.loading && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="mr-2 h-4 w-4 animate-spin"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 6V3m4.25 4.75L18.4 5.6M18 12h3m-4.75 4.25l2.15 2.15M12 18v3m-4.25-4.75L5.6 18.4M6 12H3m4.75-4.25L5.6 5.6"
          />
          <title>Loading</title>
        </svg>
      )}
      {!props.loading && (
        <Icon icon={props.icon} />
      )}
    </Button>
  );
}

export const CreateButton = (props) => {
  const [local, rest] = splitProps(props, ["href", "class", "children"]);
  return (
    <Button variant="outline" as={(innerProps) => <a href={local.href} {...innerProps} {...rest} />}>
      <Icon icon="stash:plus-solid" class="me-2" />
      {props.children}
    </Button>
  );
}

export const CreateModalTrigger = (props) => {
  const [local, rest] = splitProps(props, ["children"]);
  return (
    <Button variant="outline" {...rest}>
      <Icon icon="stash:plus-solid" class="me-2" />
      {props.children}
    </Button>
  );
}
